import { InspectorIcon } from "../../InspectorIcon";
import {
  CheckCircle2Icon,
  CircleDashedIcon,
  CircleXIcon,
  LoaderCircleIcon,
  PauseCircleIcon,
} from "lucide-react";
import { cn } from "~/lib/utils";
import { Avatar, AvatarFallback } from "../../ui/avatar";
import { Badge } from "../../ui/badge";
import { STATUS_PILL, type InspectionStatus } from "./inspectorView";
const icons = {
  queued: CircleDashedIcon,
  running: LoaderCircleIcon,
  completed: CheckCircle2Icon,
  failed: CircleXIcon,
  interrupted: PauseCircleIcon,
};
/** shadcn's data-table status: an outline badge, the icon carries the colour. */
export function InspectionStatusBadge({ status }: { status: InspectionStatus }) {
  const Icon = icons[status];
  const pill = STATUS_PILL[status];
  return (
    <Badge variant="outline" className="gap-1 px-1.5 text-muted-foreground">
      <Icon
        aria-hidden
        className={cn("size-3", pill.iconClassName, status === "running" && "animate-spin motion-reduce:animate-none")}
      />
      {pill.label}
    </Badge>
  );
}
/**
 * The Inspector mark as a workspace avatar.
 *
 * Composed from the shared Avatar primitive so every surface that shows the
 * agent — the chat picker, finding conversations, policy recommendations and
 * the inbox — draws it from one implementation. The chip itself is
 * background-free: the mark carries its own brand ink (near-black on light,
 * white on dark), and a tinted surface behind it recolours the lens.
 */
export function InspectorAvatar({
  className,
  filled = false,
}: {
  className?: string;
  /**
   * An ink disc with the mark cut out of it. For lists where the Inspector
   * sits among people and organisations as an actor and needs a face of its
   * own, rather than a bare glyph on the surface.
   */
  filled?: boolean;
}) {
  return (
    <Avatar
      aria-hidden
      className={cn("size-8 rounded-lg", filled ? "bg-foreground" : "bg-transparent", className)}
    >
      <AvatarFallback className={cn(filled ? "bg-foreground text-background" : "bg-transparent")}>
        <InspectorIcon className={cn("size-4", filled && "text-background dark:text-background")} />
      </AvatarFallback>
    </Avatar>
  );
}
